import React, { useCallback } from "react";
import { formatUsPhoneAsYouType } from "../shared/utils/phoneFormat";

/**
 * Reusable phone input with light masking.
 *
 * - Keeps a controlled value (string) formatted as (###) ###-####
 * - Stores what you see (formatted) so validation and display are consistent
 * - Caller owns required/disabled/etc props like a normal <input>
 */
function PhoneInput({ value, onChange, ...rest }) {
  const handleChange = useCallback(
    (e) => {
      const next = formatUsPhoneAsYouType(e.target.value);
      if (onChange) onChange(next);
    },
    [onChange]
  );

  // type/inputMode after {...rest} so callers cannot drop the phone keypad (iOS).
  return (
    <input
      autoComplete="tel"
      {...rest}
      type="tel"
      inputMode="tel"
      value={value || ""}
      onChange={handleChange}
    />
  );
}

export default PhoneInput;

